import { navigate, useIntl } from 'gatsby-plugin-intl'
import React, { useEffect } from 'react'
import Layout from '../../components/Layout/index'
import PressRelease from '../../components/PressRelease'
import SEO from '../../components/seo'
import Footer from '../../modules/Footer'
import Header from '../../modules/Header'

import Image from '../../images/news/adac-teaser.jpg'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import messages from '../../messages/pageTitles.lang'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'en') {
      navigate('/newsroom/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsAdac)}
        imageAlt={formatMessage(messages.TitleNewsAdac)}
        description={formatMessage(metaDescription.NewsAdacDescription)}
        image={Image}
        nofollow={locale === 'en'}
        lang={locale}
      />
      <PressRelease
        article={newsList.adac}
      />
    </Layout>
  )
}

export default IndexPage
